// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./sprite-small-preloader-white.png");
var dir = previousRequest.replace("sprite-small-preloader-white.png", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "sprite-small-preloader-white.png",
	name: "sprite-small-preloader-white",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/sprite-small-preloader-white.png
// module id = 5
// module chunks = 4